export const SET_ENDERECO_PAIS = "SET_ENDERECO_PAIS";
export const LOADING_ENDERECO_PAIS = "LOADING_ENDERECO_PAIS";
export const ERROR_ENDERECO_PAIS = "ERROR_ENDERECO_PAIS";

export const SET_ENDERECO_ESTADO = "SET_ENDERECO_ESTADO";
export const LOADING_ENDERECO_ESTADO = "LOADING_ENDERECO_ESTADO";
export const ERROR_ENDERECO_ESTADO = "ERROR_ENDERECO_ESTADO";

export const SET_ENDERECO_CEP = "SET_ENDERECO_CEP";
export const LOADING_ENDERECO_CEP= "LOADING_ENDERECO_CEP";
export const ERROR_ENDERECO_CEP = "ERROR_ENDERECO_CEP";

export const CHANGE_ENDERECO_VALUE_FORM = "CHANGE_ENDERECO_VALUE_FORM";
export const HANDLER_CHANGE_TYPEAHEAD = "HANDLER_CHANGE_TYPEAHEAD";
export const SET_ID_DDIPAIS_ENDERECO = "SET_ID_DDIPAIS_ENDERECO";


